// extracted by mini-css-extract-plugin
export default {"statisticsRight":"statisticsRight___nLcaW","imgCard":"imgCard___Ml2zw","panelCard":"panelCard___vtbrP","linkList":"linkList___LxTbi","linkListItem":"linkListItem___O6Rzc"};